import React, { FunctionComponent, useEffect, useRef } from 'react';
import { PanoViewer } from '@egjs/view360';
import panoramicInteriorStyles from './panoramicInteriorStyles';
import { Box } from '@material-ui/core';

export interface IPanoramicInteriorProps {
  interiorImageUrl: string;
}

const PanoramicInterior: FunctionComponent<IPanoramicInteriorProps> = ({ interiorImageUrl }) => {
  const panoramicRef = useRef(null);
  const styles = panoramicInteriorStyles();

  useEffect(() => {
    if (panoramicRef?.current) {
      new PanoViewer(panoramicRef.current, {
        useZoom: false,
        image: interiorImageUrl,
        fov: 70,
      });
    }
  }, [interiorImageUrl]);

  return (
    <Box className={styles.interiorImageContainer} data-test="image_display:panoramic_interior">
      <div ref={panoramicRef} className={styles.interiorImg} />
    </Box>
  );
};

export default PanoramicInterior;
